import { useEffect, useMemo, useRef } from "react"

import { QuillStatic } from "../../types"

import { registerMultipleSendTagModule } from "./module"
import { MultipleSendTagProps, MultipleSendTagValueForGet } from "./types"
import { 
  MULTIPLE_SEND_TAG_BLOT_NAME, 
  MULTIPLE_SEND_TAG_MODULE_NAME, 
} from "./constants"

export const registerMultipleSendTag = (Quill: QuillStatic) => {
  registerMultipleSendTagModule(Quill)
}

export const useMultipleSendTagModules = (modules: {
  [key: string]: any
} = {}, props: MultipleSendTagProps = {}) => {
  const isActivatedMultipleSendTag = !!props.multipleSendTag

  const onClickMultipleSendTagRef = useRef<(
    el: HTMLElement, 
    value: MultipleSendTagValueForGet,
  ) => void>()
  const onRemoveMultipleSendTagRef = useRef<(value: string) => void>()

  useEffect(() => {
    if (!!props.multipleSendTag && typeof props.multipleSendTag === 'object') {
      onClickMultipleSendTagRef.current = props.multipleSendTag?.onClick
      onRemoveMultipleSendTagRef.current = props.multipleSendTag?.onRemove
    }
    else {
      onClickMultipleSendTagRef.current = undefined
      onRemoveMultipleSendTagRef.current = undefined
    }
  }, [props.multipleSendTag])

  const memoizedModules = useMemo(() => {
    const mergedModules = {
      ...modules,
    }

    if (isActivatedMultipleSendTag) {
      mergedModules[MULTIPLE_SEND_TAG_MODULE_NAME] = {
        onClick: (
          el: HTMLElement, 
          value: MultipleSendTagValueForGet,
        ) => onClickMultipleSendTagRef.current?.(el, value),
        onRemove: (value: string) => (
          onRemoveMultipleSendTagRef.current?.(value)
        ),
      }
    }

    return mergedModules
  }, [modules, isActivatedMultipleSendTag])

  return memoizedModules
}

export const useMultipleSendTagFormats = (
  formats: string[] = [], 
  props: MultipleSendTagProps = {},
) => {
  const isActivatedMultipleSendTag = !!props.multipleSendTag
  
  const memoizedFormats = useMemo(() => {
    const mergedFormats = [
      ...formats,
    ]

    if (isActivatedMultipleSendTag) {
      mergedFormats.push(MULTIPLE_SEND_TAG_BLOT_NAME)
    }

    return mergedFormats
  }, [formats, isActivatedMultipleSendTag])

  return memoizedFormats
}
